import { render, staticRenderFns } from "./IconWorkkamiBgBlue.vue?vue&type=template&id=f7cbc11c&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports